"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _immutable = require("immutable");

var TimezoneGroups = /*#__PURE__*/function () {
  function TimezoneGroups(val) {
    (0, _classCallCheck2.default)(this, TimezoneGroups);
    this.groups = (0, _immutable.List)(val);
  }

  (0, _createClass2.default)(TimezoneGroups, [{
    key: "groupForMomentTimezone",
    value: function groupForMomentTimezone(timezone) {
      return this.groups.find(function (g) {
        return g.timezones.some(function (tz) {
          return tz.momentTimezones.includes(timezone);
        });
      });
    }
  }, {
    key: "resolve",
    value: function resolve(timezone, defaultTz) {
      var groupForTimezone = this.groupForMomentTimezone(timezone);

      if (groupForTimezone === undefined) {
        groupForTimezone = this.groupForMomentTimezone(defaultTz);
        timezone = defaultTz;
      }

      return groupForTimezone.timezoneForMomentTimezone(timezone).identifier();
    }
  }]);
  return TimezoneGroups;
}();

exports.default = TimezoneGroups;
module.exports = exports.default;